import { ColDef, ColumnState } from 'ag-grid-community';

import { FIXED_COL_IDS } from '@/shared/components/ui/data-table/components/ag-grid-table-core/ag-grid-table-core.constants';
import {
  PAGE_QUERY_PARAM,
  PAGE_SIZE_QUERY_PARAM,
  TRANSIENT_QUERY_PARAMS,
} from '@/shared/components/ui/data-table/hooks/use-filter-params/use-filter-params.constants';
import { TToggleableColumn } from '@/shared/features/filter-preferences/hooks/use-table-view-settings/use-table-view-settings.types';

// The page number is deliberately dropped: only the local layer remembers it.
const EXCLUDED = [
  ...TRANSIENT_QUERY_PARAMS,
  PAGE_QUERY_PARAM,
  PAGE_SIZE_QUERY_PARAM,
];

export const toSavedFilters = (
  searchParams: URLSearchParams,
  unsavedParams: readonly string[] = [],
): Record<string, string> =>
  Object.fromEntries(
    Array.from(searchParams.entries()).filter(
      ([param]) => !EXCLUDED.includes(param) && !unsavedParams.includes(param),
    ),
  );

// Headerless columns are excluded too -- they would render as a nameless row.
export const getToggleableColumns = (
  colDefs: ColDef[],
  columnState: ColumnState[] = [],
): TToggleableColumn[] =>
  colDefs
    .map((colDef) => ({
      colId: colDef.colId ?? colDef.field ?? '',
      headerName: colDef.headerName ?? '',
    }))
    .filter(
      ({ colId, headerName }) =>
        colId && headerName && !FIXED_COL_IDS.includes(colId),
    )
    .map((column) => ({
      ...column,
      visible:
        columnState.find(({ colId }) => colId === column.colId)?.hide !== true,
    }));
